import { Box, Skeleton, SxProps, Theme } from "@mui/material";

type SkeletonTextFieldProps = {
    height?: number;
    sx?: SxProps<Theme>;
};

export function SkeletonTextField({
    height = 56,
    sx,
}: SkeletonTextFieldProps) {
    return (
        <Box sx={{ mt: { xs: 1, md: 2 }, mb: { xs: 1, md: 2 }, ...sx }}>
            <Skeleton
                animation="wave"
                variant="rectangular"
                height={height}
                sx={{ borderRadius: "10px" }}
            />
        </Box>
    );
}
